/* eslint-disable max-len */
/* eslint-disable react/jsx-filename-extension */
import { DashboardOutlined } from '@ant-design/icons';
import React from 'react';
import {
  AiFillSetting,
  AiOutlineBook,
  AiOutlineFileSearch,
  AiOutlineSolution,
  AiOutlineApartment,
  AiOutlineTeam,
  AiOutlineUserAdd,
  AiOutlineDollar,
  AiTwotoneContainer,
  AiFillClockCircle,
} from 'react-icons/ai';
import {
  FaHandHoldingUsd,
  FaMoneyBill,
} from 'react-icons/fa';
import Dashboard from 'views/Dashboard';

// Componentes de las rutas
import TipoAsignacionPlaza, { tipodeasignaciondeplazaPermission } from 'components/Catalogos/TipoAsignacionPlaza';
import Acreedores, { acreedorPermission } from 'views/Configuracion/Accesos/Acreedores';
import AdministracionDePlaza, { administracionDePlazaPermission } from 'views/Configuracion/Accesos/AdministracionDePlazas';
// import AutorizacionDeVacantes, { aurorizacionDeVacantes } from 'views/Configuracion/Accesos/AutorizacionDeVacantes';
import CaracterDeNombramiento, { caracterDeNombramientoPermission } from 'views/Configuracion/Accesos/CaracterDeNombramiento';
import CategoriaDePuesto, { categoriasDePuestosPermission } from 'views/Configuracion/Accesos/CategoriaDePuestos';
import CierreDePrenomina from 'views/Configuracion/Accesos/CierreDePrenomina';
import ConfiguracionSolicitudes, { configuracionSolicitudPermission } from 'views/Configuracion/Accesos/ConfiguracionSolicitudes';
import ConstanciaDeAportaciones from 'views/Configuracion/Accesos/Consultas/ConstanciaDeAportaciones';
import ConsultaComprobanteDeSupervivencia from 'views/Configuracion/Accesos/Consultas/ConsultaComprobanteDeSupervivencia';
import ConsultaDeNomina from 'views/Configuracion/Accesos/Consultas/ConsultaDeNomina';
import ConsultaRetencionDePago from 'views/Configuracion/Accesos/Consultas/ConsultaRetencionDePago';
import ConsultasDeNombramientos, { ConsultasNombramientosPermission } from 'views/Configuracion/Accesos/Consultas/ConsultasDeNombramientos';
import DescuentoDeAhorroYPrestamo from 'views/Configuracion/Accesos/Consultas/DescuentoDeAhorroYPrestamo';
import ExpedienteDelEmpleado from 'views/Configuracion/Accesos/Consultas/ExpedienteDelEmpleado';
import { historialComprobanteDeSupervivenciaPermission } from 'views/Configuracion/Accesos/Consultas/HistorialComprobanteDeSupervivencia';
import Deduccion, { deduccionPermission } from 'views/Configuracion/Accesos/Deducciones';
import Descuento, { descuentosPermission } from 'views/Configuracion/Accesos/Descuentos';
import DescuentoAcumulado, { descuentosAcumuladosPermission } from 'views/Configuracion/Accesos/DescuentosAcumulados';
import DescuentosNoAplicados, { descuentosNoAplicadosPermission } from 'views/Configuracion/Accesos/DescuentosNoAplicados';
import DescuentosConfiguraciones, { descuentosConfiguacionesPermission } from 'views/Configuracion/Accesos/DescuentosConfiguraciones';
import DescuentoSaldo, { descuentosSaldosPermission } from 'views/Configuracion/Accesos/DescuentosSaldos';
import DirectorioAreas, { directorioAreasPermission } from 'views/Configuracion/Accesos/DirectorioAreas';
import Empleados, { empleadosPermission } from 'views/Configuracion/Accesos/Empleados';
import ImpresionDeGafetes, { impresionDeGafetesPermission } from 'views/Configuracion/Accesos/ImpresionDeGafetes';
import HistoricoSBCEmpleado, { historicosbcempleadoPermission } from 'views/Configuracion/Accesos/HistoricoSBCEmpleado';
import HistoricoSindicato, { historicodesindicatoPermission } from 'views/Configuracion/Accesos/HistoricoSindicato';
import FuentesDeReclutamiento, { fuentesDeReclutamientoPermission } from 'views/Configuracion/Accesos/FuentesDeReclutamiento';
import FuncionesDeUsuario, { usuarioFuncionPermission } from 'views/Configuracion/Accesos/FuncionesDeUsuario';
import HistoricoPlazas, { historicoPlazaPermission } from 'views/Configuracion/Accesos/HistoricoPlazas';
import HistorialSueldoPlaza, { historialSueldoPlazaPermission } from 'views/Configuracion/Accesos/HistorialSueldoPlaza';
import ImporteAnualISR, { importeAnualISRPermission } from 'views/Configuracion/Accesos/ImporteAnualISR';
import ConfiguracionIncidencias, { configuracionIncidenciaPermission } from 'views/Configuracion/Accesos/Incidencias/ConfiguracionIncidencias';
import IncidenciaEmpleado, { incidenciasPermission } from 'views/Configuracion/Accesos/Incidencias/IncidenciasEmpleados';
import IncidenciaPersonalizada, { incidenciaPersonalizadaPermission } from 'views/Configuracion/Accesos/Incidencias/IncidenciasPersonalizadas';
import IsrCalculoAnual, { calculoAnualISRPermission } from 'views/Configuracion/Accesos/IsrCalculoAnualEncabezado';
import TiposDeGasto, { tipoDeGastoPermission } from 'views/Configuracion/Accesos/LiquidacionesEmpleados/TiposDeGasto';
import ListadoDeVacantes, { listadoDeVacantes } from 'views/Configuracion/Accesos/ListadoDeVacantes';
import MotivoDeMovimientoDeEmpleados, { motivoDeMovimientoDeEmpleadosPermission } from 'views/Configuracion/Accesos/MotivoDeMovimientoDeEmpleados';
import MotivoRecutamiento from 'views/Configuracion/Accesos/MotivoReclutamiento';
import MotivosBajaNombramientos, { motivosBajaNombramientosPermission } from 'views/Configuracion/Accesos/MotivosBajaNombramientos';
import MotivosDeLiquidaciones, { motivosDeLiquidacionesPermission } from 'views/Configuracion/Accesos/MotivosDeLiquidaciones';
import MotivosDeRetencionDePagos, { motivosDeRetencionDePagosPermission } from 'views/Configuracion/Accesos/MotivosDeRetencionDePagos';
import MotivosDeSuspensionDePagos, { motivodesuspensiondepagoPermission } from 'views/Configuracion/Accesos/MotivosDeSuspensionDePagos';
import NivelSalarialTabular, { nivelSalarialTabularPermission } from 'views/Configuracion/Accesos/NivelesSalarialesTabulares';
import NombramientosPrestaciones, { presentacionparanombramientoPermission } from 'views/Configuracion/Accesos/NombramientosPrestaciones';
import NominasRetencionDePagos, { retencionDePagosPermission } from 'views/Configuracion/Accesos/NominasRetencionDePagos';
import Organigrama from 'views/Configuracion/Accesos/Organigrama';
import Percepcion, { percepcionesPermission } from 'views/Configuracion/Accesos/Percepciones';
import PercepcionConfiguracionISN, { percepcionConfiguracionISNPermission } from 'views/Configuracion/Accesos/PercepcionesConfiguracionesISN';
import PercepcionConfiguracionISR, { percepcionConfiguracionISRPermission } from 'views/Configuracion/Accesos/PercepcionesConfiguracionesISR';
import PercepcionIMSS, { PercepcionIMSSPermission } from 'views/Configuracion/Accesos/PercepcionesImss';
import PercepcionISSSTE, { PercepcionISSSTEPermission } from 'views/Configuracion/Accesos/PercepcionesIsste';
import PeriodicidadDePercepcion, { periodicidadDePercepcionPermission } from 'views/Configuracion/Accesos/PeriodicidadDePercepciones';
import PeriodoDeNomina, { periodoDeNominaPermission } from 'views/Configuracion/Accesos/PeriodosDeNominas';
import CalendarioDeNominas, { calendarioDeNominaPermission } from 'views/Configuracion/Accesos/CalendarioDeNominas';
import NominasPorColaborador, { nominasPorColaboradorPermission } from 'views/Configuracion/Accesos/NominasPorColaborador';
import Plazas, { plazasPermission } from 'views/Configuracion/Accesos/Plazas';
import PreferenciaPartidaria, { preferenciapartidariaPermission } from 'views/Configuracion/Accesos/PreferenciaPartidaria';
import PrevisionSocialExenta, { previsionSocialExentaPermission } from 'views/Configuracion/Accesos/PrevisionSocialExenta';
import LimitacionAdministracionPlazas, { limitacionAdministracionPlazasPermission } from 'views/Configuracion/Accesos/LimitacionAdministracionPlazas';
import LimitacionAutorizacionContrataciones, { limitacionAutorizacionContratacionesPermission } from 'views/Configuracion/Accesos/LimitacionAutorizacionContrataciones';
import LimitacionAutorizacionNombramientos, { limitacionAutorizacionNombramientosPermission } from 'views/Configuracion/Accesos/LimitacionAutorizacionNombramientos';
import ProyectosPresupuestales from 'views/Configuracion/Accesos/ProyectosPresupuestales';
import Puesto, { puestosPermission } from 'views/Configuracion/Accesos/Puestos';
import ReclutamientoRH, { reclutamientoRHPermission } from 'views/Configuracion/Accesos/ReclutamientoRH';
import RetiroDeAhorros, { retiroDeAhorrosPermission } from 'views/Configuracion/Accesos/RetiroDeAhorros';
import ConstructorDeGraficas from 'views/Configuracion/ConstructorDeGraficas';
import RolesDeUsuario, { rolesUsuariosPermission } from 'views/Configuracion/Accesos/RolesDeUsuario';
import RolesYUsuarios, { rolesYUsuariosPermission } from 'views/Configuracion/Accesos/RolesYUsuarios';
import PermisosSidebar, { permisosSidebarPermission } from 'views/Configuracion/Accesos/PermisosSidebar';
import SalarioMinimoGeneral, { salarioMinimoGeneralPermission } from 'views/Configuracion/Accesos/SalarioMinimoGeneral';
import SalarioMinimoMunicipal, { salarioMinimoMunicipalPermission } from 'views/Configuracion/Accesos/SalarioMinimoMunicipal';
import Seguridadsocial, { SeguridadSocialPermission } from 'views/Configuracion/Accesos/SeguridadSocial';
import SolcitudesParametros, { solicitudParametroPermission } from 'views/Configuracion/Accesos/SolicitudesParametros';
import SolicitudesPercepciones, { solicitudesPercepcionesPermission } from 'views/Configuracion/Accesos/SolicitudesPercepciones';
import Subsidio, { subsidioPermission } from 'views/Configuracion/Accesos/Subsidio';
import SuspensionDePagos, { suspensionDePagosPermission } from 'views/Configuracion/Accesos/SuspensionDePagos';
import TabuladorGeneral, { tabuladorGeneralPermission } from 'views/Configuracion/Accesos/TabuladoresGenerales';
import TabuladorNominal, { tabuladorNominalPermission } from 'views/Configuracion/Accesos/TabuladoresNominales';
import TarifaISR, { tarifaPermission } from 'views/Configuracion/Accesos/TarifaISR';
import TarifaISN, { tarifasISNPermission } from 'views/Configuracion/Accesos/TarifasISN';
import TimbradoNominas, { timbradoNominaPermission } from 'views/Configuracion/Accesos/TimbradoNominas';
import TiposDeChecado, { tipoDeChecadoPermission } from 'components/Catalogos/Reloj Checador/TiposDeChecado';
import TiposDeDescuentos, { tiposDescuentoPermission } from 'views/Configuracion/Accesos/TiposDeDescuentos';
import TiposDeFunciones, { tipoDeFuncionPermission } from 'views/Configuracion/Accesos/TiposDeFunciones';
import TiposDePlazas, { tiposDePlazasPermission } from 'views/Configuracion/Accesos/TiposDePlazas';
import TipoDeNominaEmpleado, { tipoDeNominaEmpleadoPermission } from 'views/Configuracion/Accesos/TiposNominasEmpleados';
import UmaGeneral, { umasGeneralesPermission } from 'views/Configuracion/Accesos/UmasGenerales';
import Usuarios, { usuariosPermission } from 'views/Configuracion/Accesos/Usuarios';
import VacacionesConfiguracion, { vacacionesConfiguracionPermission } from 'views/Configuracion/Accesos/VacacionesConfiguracion';
import VacacionesRegistros, { vacacionesRegistrosPermission } from 'views/Configuracion/Accesos/VacacionesRegistros';
import EntidadMunicipal, { entidadPermission } from 'views/Configuracion/EntidadMunicipal';
import ClasificadorPorObjetoDelGasto, { clasificadorPorObjetoDelGastoPermission } from 'views/Configuracion/Otros/ClasificadorPorObjetoDelGasto';
import PeriodoFiscal, { periodosFiscalesPermission } from 'views/Configuracion/Otros/PeriodoFiscal';
import IconografiaDeSeguimiento, { permissionIconografiaDeSeguimiento } from 'views/Configuracion/Otros/IconografiaDeSeguimiento';
import CategoriaDeIconografia, { permissionCategoriaDeIconografia } from 'views/Configuracion/Catalogos/Otros/CategoriaDeIconografia';
import ClavesContables, { permissionCuentaContable } from 'views/Contabilidad/ClavesContables';
import FuenteDeFinanciamiento, { permissionFuenteDeFinanciamiento } from 'views/Contabilidad/FuenteDeFinanciamiento';
import CargaExternaDescuento, { CargaExternaDescuentoPermission } from 'views/Configuracion/Accesos/CargaExternaDescuentos';
import ConfiguracionCargaExternaDescuento, { ConfiguracionCargaExternaDescuentoPermission } from 'views/Configuracion/Accesos/ConfiguracionCargaExternaDescuento';
import ConfiguradorPolizasCargaExterna, { configuradorPolizasCargaExternaPermission } from 'views/Configuracion/Accesos/ConfiguradorPolizasCargaExterna';
import AcumuladosNominasColumnas, { acumuladoNominaColumnaPermission } from 'views/Configuracion/Accesos/AcumuladosNominasColumnas';
// PRUEBA - BORRAR DESPUES: pantalla temporal para probar la generacion de polizas
import PruebaGeneradorPolizasCargaExterna from 'views/Configuracion/Accesos/PruebaGeneradorPolizasCargaExterna';
import IncidenciaGeneral, { incidenciaGeneralPermission } from 'views/Configuracion/Accesos/configuracionReloj/GeneralConfigReloj';
import ClockJustificacion, { tipoDeJustificacionPermission } from 'components/Catalogos/Reloj Checador/TipoJustificacion';
import ClockEvaluacionAsistencia, { tipoDeEvaluacionAsistenciaPermission } from 'components/Catalogos/Reloj Checador/TipoEvaluacionAsistencia';
import ClockRelojChecador, { tipoDeRelojChecadorPermission } from 'components/Catalogos/Reloj Checador/TipoRelojChecador';
import ClockPeriocidad from 'components/Catalogos/Reloj Checador/PeriocidadAplicacion';
import CargaReporteReloj, { CargaReporteRelojPermission } from 'views/Configuracion/Accesos/Reloj/Carga de Reporte/CargaReporteReloj';
import DiasFestivosReloj, { diasFestivosRelojPermission } from 'views/Configuracion/Accesos/DiasFestivosReloj';
import ParamaetrosConfigReloj, { ParametrosConfigPermission } from 'views/Configuracion/Accesos/configuracionReloj/ParametrosConfigReloj';
import CargaConfigReloj, { cargaConfigPermission } from 'views/Configuracion/Accesos/configuracionReloj/CargaConfigReloj';
import RelacionConfigReloj, { relacionConfigPermission } from 'views/Configuracion/Accesos/configuracionReloj/RelacionConfigReloj';
import ToleranciaConfigReloj, { toleranciaConfigPermission } from 'views/Configuracion/Accesos/configuracionReloj/ToleranciaConfigReloj';
import TopeJustificacionesConfigReloj, { topeJustificacionesConfigPermission } from 'views/Configuracion/Accesos/configuracionReloj/TopeJustificacionesConfigReloj';
import PeriodicidadConfigReloj, { periodicidadConfigPermission } from 'views/Configuracion/Accesos/configuracionReloj/PeriodicidadConfigReloj';
import JornadaModificacion, { modificaciondejornadaPermission } from 'views/Configuracion/Accesos/JornadaModificacion';
import ValidacionesConfigReloj, { validacionesConfigPermission } from 'views/Configuracion/Accesos/configuracionReloj/ValidacionConfigReloj';
import CitasCalendarioPantalla from 'components/Reclutamiento/CitasPantalla';
import EstructurasJerarquicas from 'views/Configuracion/Accesos/EstructurasJerarquicas';
import Entrevistas from 'components/Reclutamiento/Entrevistas/Entrevistas';
import JustificacionReloj, { justificacionRelojPermission } from 'views/Configuracion/Accesos/Reloj/Justificacion/Justificacion';
import ClaseDeContratacion, { claseDeContratacionPermission } from 'views/Configuracion/Accesos/ClasesDeContrataciones';
import EntrevistaInforme from 'components/Reclutamiento/Informe';
import Contratacion from 'components/Reclutamiento/Contratacion/Contratacion';
import Contrataciones from 'components/Reclutamiento/Contratacion';
import TiposDeActividades, { tiposDeActividadesPermission } from 'views/Configuracion/Accesos/TiposDeActividades';
import TiposDeMovimientosDePersonal, { tipodemovimientodepersonalPermission } from 'views/Configuracion/Accesos/TiposDeMovimientosDePersonal';
import MovimientosDePersonal, { movimientodepersonalPermission } from 'views/Configuracion/Accesos/MovimientosDePersonal';
import PruebasYOtros, { pruebasYOtrosPermission } from 'views/Configuracion/Accesos/PruebasYOtros';
import CatalogoContable from 'views/Contabilidad/ClavesContables2';
import Vacantes from 'components/Reclutamiento/Vacantes/Vacantes';
import VacantesCandidatos from 'components/Reclutamiento/Pruebas/VacantesCandidatos';
import ValidacionesAusentismoReloj, { validacionesAusentismoPermission } from 'views/Configuracion/Accesos/Reloj/Validaciones/ValidacionesAusentismo';
import Becarios from 'views/Configuracion/Accesos/Becarios';
import HonorariosAsimilados from 'views/Configuracion/Accesos/HonorariosAsimilados';
import ConfiguradorDeContribucionesPlaza, { contribucionesPlazaPermission } from 'views/Configuracion/Accesos/ConfiguradorContribucionesPlaza';
import ConfiguradorFirmadoDeDocumentos, { configuradorFirmadoDeDocumentosPermission } from 'views/Configuracion/Accesos/ConfiguradorFirmadoDeDocumentos';
import EvaluacionGeneralReloj, { evaluacionRelojPermission } from 'views/Configuracion/Accesos/Reloj/Evaluacion/EvaluacionGeneral';
import IncidenciasReloj, { incidenciaRelojPermission } from 'views/Configuracion/Accesos/Reloj/Incidencias/Incidencias';
import ClavesPresupuestales from 'views/Configuracion/Accesos/ClavesPresupuestales';
import PresupuestoPlazasAnual from 'views/Configuracion/Accesos/PresupuestoPlazasAnual';
import PresupuestoAnualNomina, { permissionPresupuestoAnualNomina } from 'views/Configuracion/Accesos/PresupuestoAnualNomina';
import ModificacionesPresupuestales, { permissionModificacionesPresupuestalesNomina } from 'views/Configuracion/Accesos/ModificacionesPresupuestales';
import AvancePresupuestalNomina, { permissionAvancePresupuestalNomina } from 'views/Configuracion/Accesos/AvancePresupuestalNomina';
import presupuestoPlazasmensual from 'views/Configuracion/Accesos/PresupuestoPlazasMensual';
import AplicacionPresupuestalPlazas from 'views/Configuracion/Accesos/AplicacionPresupuestalPlazas';
import PresupuestoPlazasComparativo from 'views/Configuracion/Accesos/PresupuestoPlazasComparativo';
import ClasificacionProgramatica, { permissionClasificacionProgramatica } from 'views/Configuracion/Accesos/ClasificacionProgramatica';
import FuncionesPresupuestales, { permissionFuncionesPresupuestales } from 'views/Configuracion/Accesos/FuncionesPresupuestales';
import ClasificacionAdministrativa, { permissionClasificacionAdministrativa } from 'views/Configuracion/Accesos/ClasificacionAdministrativa';
import ClasificacionFuncional, { permissionClasificacionFuncional } from 'views/Configuracion/Accesos/ClasificacionFuncional';
import { Component } from 'devextreme-react/cjs/core/component';
import AsignacionSegSocial, { AsignacionSegSocialPermission } from 'views/Configuracion/Accesos/AsignacionSegSocial';
import CalendarioPagosIMSS from 'views/Configuracion/Accesos/CalendarioPagosIMSS';
import ConfiguracionSeguroIMSS, { ConfiguracionSeguroIMSSPermission } from 'views/Configuracion/Accesos/ConfiguracionSeguroIMSS';
import ConfiguracionSeguroISSSTE, { ConfiguracionSeguroISSSTEPermission } from 'views/Configuracion/Accesos/ConfiguracionSeguroISSSTE';
import CalendarioPagosISSSTE, { CalendarioPagosISSSTEPermission } from 'views/Configuracion/Accesos/CalendarioPagosISSSTE';
import PercepcionConfiguracionIPEJAL, { percepcionConfiguracionIPEJALPermission } from 'views/Configuracion/Accesos/PercepcionesConfiguracionesIPEJAL';
import TasasIPEJAL, { tasasIPEJALPermission } from 'views/Configuracion/Accesos/TasasIPEJAL';
import FactorSBC from 'views/Configuracion/Accesos/FactorSBC';
import SBCVariable, { sbcVariablePermission } from 'views/Configuracion/Accesos/SBCvariable';
import CandidatoAutorizacion from 'components/Reclutamiento/AutorizarContratación';
import ProgramasPresupuestales, { programasPresupuestalesPermission } from 'views/Configuracion/Accesos/ProgramasPresupuestales';
import TipoDeOrigenDeContratacion, { tipodeorigendecontratacionPermission } from 'views/Configuracion/Accesos/TipoDeOrigenDeContratacion';
import TipoDeEmpleadoPresupuestal, { tipodeempleadopresupuestalPermission } from 'views/Configuracion/Accesos/TipoDeEmpleadoPresupuestal';
import KardexSbcEmpleado, { kardexSbcEmpleadoPermission } from 'views/Configuracion/Accesos/KardexSbcEmpleado';
import IncidenciaAntiguedadParaEnfermedadGeneral, { incidenciaAntiguedadParaEnfermedadGeneralPermission } from 'components/Nominas/Incidencias/IncidenciaAntiguedadParaEnfermedadGeneral';
import TopeSbcImss, { topeSbcImssPermission } from 'views/Configuracion/Accesos/TopeSbcImss';
import Bimestre, { bimestrePermission } from 'views/Configuracion/Accesos/Bimestre';
import ConfigurarPeriodosVacacionales, { configurarPeriodosVacacionalesPermission } from 'views/Configuracion/Accesos/GuardiasVacaciones/ConfigurarPeriodosVacacionales';
import ConfigurarGuardiasVacacionalesGeneral, { configurarGuardiasVacacionalesGeneralPermission } from 'views/Configuracion/Accesos/GuardiasVacaciones/ConfigurarGuardiasVacacionalesGeneral';
import RegistroGuardiasPrincipal, { registroGuardiasPrincipalPermission } from 'views/Configuracion/Accesos/GuardiasVacaciones/RegistroGuardias/RegistroGuadiasPrincipal';
import RegistroGuardiasMenu from 'views/Configuracion/Accesos/GuardiasVacaciones/RegistroGuardias/RegistroGuardiasMenu';
import AreaExterna, { areaexternaPermission } from 'views/Configuracion/Accesos/AreaExterna';
import ConfiguradorNombramientos, { configuracionnombramientoPermission } from 'views/Configuracion/Accesos/ConfiguracionNombramientos';
import DestinosPresupuestales, { permissionDestinosPresupuestales } from 'components/Catalogos/DestinosPresupuestales';
import VacantesCandidatosMenu from 'components/Reclutamiento/Vacantes/VacantesCandidatosMenu';
import ExpedienteDeCandidato from 'views/Configuracion/Accesos/ExpedienteDeCandidatos';
import ConfiguradorNombramientosMenu from 'views/Configuracion/Accesos/ConfiguradorNombramientosMenu';
import AbreviaturaDeCarrera, { abreviaturadecarreraPermission } from '../views/Configuracion/Accesos/AbreviaturasDeCarreras';
import AdministracionDeTarjetasDePago, { administracionDeTarjetasDePagoPermission } from '../views/Configuracion/Accesos/AdministracionDeTarjetasDePago';
import Banco, { bancodenominaPermission } from '../views/Configuracion/Accesos/Banco';
import CalculosDeNominaEncabezado, { calculosDeNominaEncabezadoPermission } from '../views/Configuracion/Accesos/CalculosDeNominaEncabezado';
import CategoriasIncapacidades, { categoriaIncapacidadesPermission } from '../views/Configuracion/Accesos/CategoriaIncapacidades';
import ComprobantesDeEstudios, { comprobantedeestudioPermission } from '../views/Configuracion/Accesos/ComprobantesDeEstudios';
import CapacidadCredito from '../views/Configuracion/Accesos/Consultas/CapacidadCredito';
import ConsultaVacaciones from '../views/Configuracion/Accesos/Consultas/ConsultaVacaciones';
import ReciboFiniquito from '../views/Configuracion/Accesos/Consultas/ReciboFiniquito';
import DescuentoAsignacionMasiva, { descuentoasignacionmasivaPermission } from '../views/Configuracion/Accesos/DescuentosAsignacionMasiva';
import EspecialidadDeEstudio, {
  especialidadesDeEstudiosPermission,
} from '../views/Configuracion/Accesos/EspecialidadesDeEstudios';
import Jornada, { jornadaPermission } from '../views/Configuracion/Accesos/Jornadas';
import Liquidaciones, { liquidacionesPermission } from '../views/Configuracion/Accesos/Liquidaciones';
import LiquidacionesConfiguraciones, { liquidacionConfiguracionPermission } from '../views/Configuracion/Accesos/LiquidacionesConfiguraciones';
import DocumentosParaLiquidaciones, { documentosParaLiquidacionesPermission } from '../views/Configuracion/Accesos/DocumentosParaLiquidaciones';
import LiquidacionesEmpleados, { liquidacionEmpleadoPermission } from '../views/Configuracion/Accesos/LiquidacionesEmpleados/LiquidacionesEmpleados';
import MotivoPermisos, { motivoPermisosPermission } from '../views/Configuracion/Accesos/MotivoPermisos';
import NivelDeEstudio, { niveldeestudioPermission } from '../views/Configuracion/Accesos/NivelesDeEstudios';
import OrigenRecurso, { origenrecursonominaPermission } from '../views/Configuracion/Accesos/OrigenRecurso';
import PeriodicidadDePago, { periodicidaddepagoPermission } from '../views/Configuracion/Accesos/PeriodicidadesDePagos';
import PeriodicidadPagoNomina, { periodicidadpagonominaPermission } from '../views/Configuracion/Accesos/PeriodicidadPagoNomina';
import PorcentajePagoSueldo, { porcentajePagoSueldoPermission } from '../views/Configuracion/Accesos/PorcentajePagoSueldo';
import RiesgoDeTrabajo, { RiesgoDeTrabajoPermission } from '../views/Configuracion/Accesos/RiesgoDeTrabajo';
import RiesgoPuesto, { riesgopuestonominaPermission } from '../views/Configuracion/Accesos/RiesgoPuesto';
import Sindicato, { sindicatoPermission } from '../views/Configuracion/Accesos/Sindicatos';
import SubcategoriasIncapacidades, { subcategoriaIncapacidadesPermission } from '../views/Configuracion/Accesos/SubcategoriaIncapacidades';
import TipoContrato, { tipocontratonominaPermission } from '../views/Configuracion/Accesos/TipoContrato';
import TipoDeduccion, { tipodeduccionnominaPermission } from '../views/Configuracion/Accesos/TipoDeduccion';
import TipoHoras, { tipohorasnominaPermission } from '../views/Configuracion/Accesos/TipoHoras';
import TipoIncapacidad, { tipoincapacidadnominaPermission } from '../views/Configuracion/Accesos/TipoIncapacidad';
import TipoJornada, { tipojornadanominaPermission } from '../views/Configuracion/Accesos/TipoJornada';
import TipoOtroPago, { otrotipopagonominaPermission } from '../views/Configuracion/Accesos/TipoOtroPago';
import TipoPercepcion, { tipopercepcionnominaPermission } from '../views/Configuracion/Accesos/TipoPercepcion';
import TipoRegimen, { tiporegimennominaPermission } from '../views/Configuracion/Accesos/TipoRegimen';
import TipoDeContratacion, { tipodecontratacionPermission } from '../views/Configuracion/Accesos/TiposDeContrataciones';
import TipoDeEmpleado, { tipodeempleadoPermission } from '../views/Configuracion/Accesos/TiposDeEmpleados';
import ConfiguracionDeSegmentos, { permissionConfigSegmentoPresupuestal } from '../views/Configuracion/Accesos/ConfiguracionDeSegmentos';
import ConfiguracionDeSegmentosContables, { permissionConfigSegmentoContable } from '../views/Configuracion/Accesos/ConfiguracionDeSegmentosContables';
import ConfiguracionDeMascaras, { permissionConfigMascara } from '../views/Configuracion/Accesos/ConfiguracionDeMascaras';
import ConfiguracionDispersionBancaria, { configuracionDispersionBancariaPermission } from '../views/Configuracion/Accesos/ConfiguracionDispersionBancaria';
import TipoDeIdentificacion, {
  tipodeidentificacionPermission,
} from '../views/Configuracion/Accesos/TiposDeIdentificaciones';
import TiposDeSeguridadesSociales, {
  tipoDeSeguridadSocialPermission,
} from '../views/Configuracion/Accesos/TiposDeSeguridadesSociales';
import ZonaDeSalarioMinimo, {
  zonaDeSalarioMinimoPermission,
} from '../views/Configuracion/Accesos/ZonasDeSalariosMinimos';
import Beneficiarios, { permissionBeneficiario } from '../views/Configuracion/Administracion/Beneficiarios';
import BitacoraAuditoria, { bitacoraAuditoriaPermission } from '../views/Configuracion/Administracion/BitacoraAuditoria';

export default [
  {
    title: 'Dashboard',
    icon: () => <DashboardOutlined />,
    component: Dashboard,
  },
  {
    title: 'Reclutamiento',
    icon: () => <AiOutlineUserAdd />,
    children: [
      {
        title: 'Vacantes',
        icon: null,
        component: ListadoDeVacantes,
        ...listadoDeVacantes,
      },

      // {
      //   title: 'Autorizacion de Vacantes',
      //   icon: null,
      //   component: AutorizacionDeVacantes,
      //   ...aurorizacionDeVacantes,
      // },
      // {
      //   title: 'Recursos Humanos',
      //   icon: null,
      //   component: RecursosHumanos,
      //   ...recursosHumanosPermission,
      // },
      {
        title: 'Asignar Pruebas',
        icon: null,
        component: Vacantes,
        ...reclutamientoRHPermission,
      },
      {
        title: 'Candidatos',
        icon: null,
        // component: VacantesCandidatos,
        component: VacantesCandidatosMenu,
        ...reclutamientoRHPermission,
      },
      {
        title: 'Historico de Candidatos',
        icon: null,
        // component: VacantesCandidatos,
        component: ExpedienteDeCandidato,
        ...reclutamientoRHPermission,
      },

      {
        title: 'Citas',
        icon: null,
        component: CitasCalendarioPantalla,
        ...reclutamientoRHPermission,
      },
      {
        title: 'Entrevistas',
        icon: null,
        component: Entrevistas,
        ...reclutamientoRHPermission,
      },
      {
        title: 'Informe',
        icon: null,
        component: EntrevistaInforme,
        ...reclutamientoRHPermission,
      },
      {
        title: 'Autorizar Contratación',
        icon: null,
        component: CandidatoAutorizacion,
        ...reclutamientoRHPermission,
      },
      {
        title: 'Contratacion',
        icon: null,
        component: Contrataciones,
        ...reclutamientoRHPermission,
      },

    ],
  },

  {
    title: 'Presupuesto de Nómina',
    icon: AiOutlineDollar,
    children: [
      {
        title: 'Presupuesto Anual de Nómina',
        sidebarTitle: 'Presupuesto Anual',
        icon: null,
        component: PresupuestoAnualNomina,
        ...permissionPresupuestoAnualNomina,
        catalogsModels: ['tipodepresupuesto'],
      },
      {
        title: 'Modificaciones Presupuestales',
        icon: null,
        component: ModificacionesPresupuestales,
        ...permissionModificacionesPresupuestalesNomina,
      },
      {
        title: 'Claves Presupuestales',
        icon: null,
        component: ClavesPresupuestales,
        ...listadoDeVacantes, // cambiar permiso
      },
      {
        title: 'Avance Presupuestal de Nómina',
        sidebarTitle: 'Avance Presupuestal',
        icon: null,
        component: AvancePresupuestalNomina,
        ...permissionAvancePresupuestalNomina,
      },
      {
        title: 'Aplicación Presupuestal Global',
        icon: null,
        component: ClavesPresupuestales,
        ...listadoDeVacantes, // cambiar permiso
      },

      {
        title: 'Presupuesto de Plazas Anual',
        icon: null,
        component: PresupuestoPlazasAnual,
        ...listadoDeVacantes, // cambiar permiso
      },
      {
        title: 'Presupuesto de Plazas Mensual',
        icon: null,
        component: presupuestoPlazasmensual,
        ...listadoDeVacantes, // cambiar permiso
      },
      {
        title: 'Comparativo Presupuestal',
        icon: null,
        component: PresupuestoPlazasComparativo,
        ...listadoDeVacantes, // cambiar permiso
      },
      {
        title: 'Aplicación Presupuestal de Plazas',
        icon: null,
        component: AplicacionPresupuestalPlazas,
        ...listadoDeVacantes, // cambiar permiso
      },

    ],
  },

  // {
  //   title: 'Clase De Contratacion',
  //   icon: null,
  //   component: ClaseDeContratacion,
  //   ...claseDeContratacionPermission,
  // },

  {
    title: 'Reloj Checador',
    icon: () => <AiFillClockCircle />,
    children: [
      {
        title: 'Carga de Reporte',
        icon: null,
        component: CargaReporteReloj,
        ...CargaReporteRelojPermission,
      },
      {
        title: 'Tipos de Reloj Checador',
        icon: null,
        component: ClockRelojChecador,
        ...tipoDeRelojChecadorPermission,
      },
      {
        title: 'Validación de Ausentismo',
        icon: null,
        component: ValidacionesAusentismoReloj,
        ...validacionesAusentismoPermission,
      },
      {
        title: 'Evaluación',
        icon: null,
        component: EvaluacionGeneralReloj,
        ...evaluacionRelojPermission,
      },
      {
        title: 'Justificaciones',
        icon: null,
        component: JustificacionReloj,
        ...justificacionRelojPermission,
      },
      {
        title: 'Incidencias R.CH',
        icon: null,
        component: IncidenciasReloj,
        ...incidenciaRelojPermission,
      },
      // {
      //  title: 'Descuentos R.CH',
      //  icon: null,
      // },
      {
        title: 'Días Festivos',
        icon: null,
        component: DiasFestivosReloj,
        ...diasFestivosRelojPermission,
      },
    ],
  },
  {
    title: 'Nómina',
    icon: () => <FaMoneyBill />,
    children: [

      {
        title: 'Cálculo de Nóminas',
        icon: null,
        component: CalculosDeNominaEncabezado,
        ...calculosDeNominaEncabezadoPermission,
      },
      {
        title: 'Pre-Nómina',
        icon: null,
        component: CierreDePrenomina,
        ...tipoDeNominaEmpleadoPermission,
      },
      {
        title: 'Timbrado de Nóminas',
        icon: null,
        component: TimbradoNominas,
        ...timbradoNominaPermission,
      },
      {
        title: 'Procesos',
        icon: null,
        children: [
          {
            title: 'Solicitudes de Percepciones',
            icon: null,
            component: SolicitudesPercepciones,
            ...solicitudesPercepcionesPermission,
          },
          {
            title: 'Descuentos',
            icon: null,
            children: [
              {
                title: 'Descuentos de Empleados',
                icon: null,
                component: Descuento,
                ...descuentosPermission,
              },
              {
                title: 'Carga Externa de Descuentos',
                icon: null,
                component: CargaExternaDescuento,
                ...CargaExternaDescuentoPermission,
              },
              {
                title: 'Asignación Masiva',
                icon: null,
                component: DescuentoAsignacionMasiva,
                ...descuentoasignacionmasivaPermission,
              },
              {
                title: 'Saldos de Descuentos',
                icon: null,
                component: DescuentoSaldo,
                ...descuentosSaldosPermission,
              },
              {
                title: 'Acumulados de Descuentos',
                icon: null,
                component: DescuentoAcumulado,
                ...descuentosAcumuladosPermission,
              },
              {
                title: 'Descuentos No Aplicados',
                icon: null,
                component: DescuentosNoAplicados,
                ...descuentosNoAplicadosPermission,
              },
              {
                title: 'Retiros de Ahorros',
                icon: null,
                component: RetiroDeAhorros,
                ...retiroDeAhorrosPermission,
              },
            ],
          },
          {
            title: 'Incidencias',
            icon: null,
            children: [
              {
                title: 'Registro de Incidencias',
                icon: null,
                component: IncidenciaEmpleado,
                ...incidenciasPermission,
              },
              {
                title: 'Incidencias por Empleado',
                icon: null,
                component: IncidenciaPersonalizada,
                ...incidenciaPersonalizadaPermission,
              },
            ],
          },
          {
            title: 'Liquidaciones',
            icon: null,
            children: [
              {
                title: 'Liquidaciones',
                icon: null,
                component: Liquidaciones,
                ...liquidacionesPermission,
              },
              {
                title: 'Liquidaciones de Empleados',
                icon: null,
                component: LiquidacionesEmpleados,
                ...liquidacionEmpleadoPermission,
              },
            ],
          },
          {
            title: 'Vacaciones',
            icon: null,
            children: [
              {
                title: 'Registro de Vacaciones',
                icon: null,
                component: VacacionesRegistros,
                ...vacacionesRegistrosPermission,
              },
            ],
          },
          {
            title: 'Suspensión de Pagos',
            icon: null,
            component: SuspensionDePagos,
            ...suspensionDePagosPermission,
          },
          {
            title: 'Registro de Guardias',
            icon: null,
            component: RegistroGuardiasMenu,
            ...registroGuardiasPrincipalPermission,
          },
          {
            title: 'Retención de Pagos',
            icon: null,
            component: NominasRetencionDePagos,
            ...retencionDePagosPermission,
          },
          {
            title: 'Cálculo Anual de ISR',
            icon: null,
            component: IsrCalculoAnual,
            ...calculoAnualISRPermission,
          },
        ],
      },
      {
        title: 'Tarjetas de Pago',
        icon: null,
        component: AdministracionDeTarjetasDePago,
        ...administracionDeTarjetasDePagoPermission,
      },

      {
        title: 'Periodos',
        icon: null,
        component: PeriodoDeNomina,
        ...periodoDeNominaPermission,
      },
      {
        title: 'Calendario de Nóminas',
        icon: null,
        component: CalendarioDeNominas,
        ...calendarioDeNominaPermission,
      },
      {
        title: 'Nóminas por Colaborador',
        icon: null,
        component: NominasPorColaborador,
        ...nominasPorColaboradorPermission,
      },
    ],
  },
  {
    title: 'Empleados',
    icon: AiOutlineTeam,
    children: [
      {
        title: 'Empleados',
        icon: null,
        component: Empleados,
        ...empleadosPermission,
      },
      {
        title: 'Impresión de Gafetes',
        icon: null,
        component: ImpresionDeGafetes,
        ...impresionDeGafetesPermission,
      },
      {
        title: 'Nombramientos',
        icon: null,
        component: ConsultasDeNombramientos,
        ...ConsultasNombramientosPermission,
      },
      {
        title: 'Configurador De Nombramientos',
        icon: null,
        component: ConfiguradorNombramientosMenu,
        ...configuracionnombramientoPermission,
      },
      {
        title: 'Jornadas',
        icon: null,
        component: Jornada,
        ...jornadaPermission,
      },
      {
        title: 'Modificacion Jornadas',
        icon: null,
        component: JornadaModificacion,
        ...modificaciondejornadaPermission,
      },
      {
        title: 'Expediente del Empleado',
        icon: null,
        component: ExpedienteDelEmpleado,
      },
      {
        title: 'Histórico SBC Empleado',
        icon: null,
        component: HistoricoSBCEmpleado,
        ...historicosbcempleadoPermission,
      },
      {
        title: 'Histórico Sindicato',
        icon: null,
        component: HistoricoSindicato,
        ...historicodesindicatoPermission,
      },
      // {
      //   title: 'Nombramientos',
      //   icon: null,
      //   component: ConsultaDeNombramiento,
      // },

    ],
  },
  {
    title: 'Becarios',
    icon: AiOutlineTeam,
    component: Becarios,
    ...listadoDeVacantes, // cambiar permiso
  },
  {
    title: 'Honorarios Asimilados',
    icon: AiOutlineTeam,
    component: HonorariosAsimilados,
    ...listadoDeVacantes, // cambiar permiso
  },
  {
    title: 'Plazas',
    icon: AiOutlineSolution,
    children: [
      {
        title: 'Puestos',
        icon: null,
        component: Puesto,
        ...puestosPermission,
      },
      {
        title: 'Tabuladores',
        icon: null,
        children: [
          {
            title: 'Tabulador General',
            icon: null,
            component: TabuladorGeneral,
            ...tabuladorGeneralPermission,
          },
          {
            title: 'Tabulador Nominal',
            icon: null,
            component: TabuladorNominal,
            ...tabuladorNominalPermission,
          },
          {
            title: 'Niveles Salariales ',
            icon: null,
            component: NivelSalarialTabular,
            ...nivelSalarialTabularPermission,
          },
        ],
      },
      {
        title: 'Plazas',
        icon: null,
        children: [
          {
            title: 'Plazas',
            icon: null,
            component: Plazas,
            ...plazasPermission,
          },
          {
            title: 'Asignación de Plazas',
            icon: null,
            component: AdministracionDePlaza,
            ...administracionDePlazaPermission,
          },
          {
            title: 'Histórico de Plazas',
            icon: null,
            component: HistoricoPlazas,
            ...historicoPlazaPermission,
          },
          {
            title: 'Historial de Sueldos de Plazas',
            icon: null,
            component: HistorialSueldoPlaza,
            ...historialSueldoPlazaPermission,
          },
        ],

      },
    ],
  },
  {
    title: 'Áreas',
    icon: AiOutlineApartment,
    children: [
      {
        title: 'Directorio de Áreas',
        component: DirectorioAreas,
      },
      {
        title: 'Organigrama',
        icon: null,
        component: Organigrama,
      },
      {
        title: 'Directorio Externo',
        icon: null,
        component: AreaExterna,
        ...puestosPermission,
        // ...areaexternaPermission,
      },
    ],
  },

  // {
  //   path: '/catalogo-contable',
  //   title: 'Catálogo Contable',
  //   icon: null,
  //   // component: blank,
  //   type: 'private',
  //   showInSidebar: true,
  // },

  {
    title: 'Contribuciones Sobre Nómina',
    icon: () => <FaHandHoldingUsd />,
    children: [
      {
        title: 'Impuesto Sobre la Renta',
        children: [
          {
            title: 'ISR Percepciones',
            icon: null,
            component: PercepcionConfiguracionISR,
            ...percepcionConfiguracionISRPermission,
          },
          {
            title: 'Tarifas de ISR',
            icon: null,
            component: TarifaISR,
            ...tarifaPermission,
          },
          {
            title: 'Tablas de Subsidios',
            icon: null,
            component: Subsidio,
            ...subsidioPermission,
          },
        ],
      },
      {
        title: 'Previsión Social Exenta',
        icon: null,
        component: PrevisionSocialExenta,
        ...previsionSocialExentaPermission,
      },
      {
        title: 'Impuesto Sobre Nómina',
        children: [
          {
            title: 'ISN Percepciones',
            icon: null,
            component: PercepcionConfiguracionISN,
            ...percepcionConfiguracionISNPermission,
          },
          {
            title: 'Tasas de ISN',
            icon: null,
            component: TarifaISN,
            ...tarifasISNPermission,
          },
        ],
      },
      {
        title: 'Seguridad Social',
        children: [
          {
            title: 'Asignación Seguridad Social',
            icon: null,
            component: AsignacionSegSocial,
            ...AsignacionSegSocialPermission,
          },
          {
            title: 'Excepciones',
            icon: null,
          },
          {
            title: 'IMSS',
            children: [
              // {
              //   title: 'Movimientos IMSS',
              //   icon: null,
              // },
              // {
              //   title: 'SUA',
              //   icon: null,
              // },
              // {
              //   title: 'IDSE',
              //   icon: null,
              // },
              {
                title: 'Periodos De Pago Del IMSS',
                icon: null,
                // component: CaledarioIMSS,
                // ...CalendarioIMSSPermission,
                component: CalendarioPagosIMSS,
                ...tarifasISNPermission,
              },
              {
                title: 'Salario Base de Cotizacion',
                children: [
                  {
                    title: 'Kárdex IMSS del Empleado',
                    icon: null,
                    component: KardexSbcEmpleado,
                    ...kardexSbcEmpleadoPermission,
                  },
                  {
                    title: 'SBC Variable',
                    icon: null,
                    component: SBCVariable,
                    ...sbcVariablePermission,
                  },
                  {
                    title: 'Factor SBC',
                    icon: null,
                    component: FactorSBC,
                    ...tarifasISNPermission, // cambiar permiso
                  },
                  {
                    title: 'Tope SBC',
                    icon: null,
                    component: TopeSbcImss,
                    ...topeSbcImssPermission, // cambiar permiso
                  },
                  {
                    title: 'Bimestres',
                    icon: null,
                    component: Bimestre,
                    ...bimestrePermission,
                  },
                ],
              },
              {
                title: 'Riesgo de Trabajo',
                icon: null,
                component: RiesgoDeTrabajo,
                ...RiesgoDeTrabajoPermission,
              },
            ],
          },
          {
            title: 'ISSSTE',
            children: [
              {
                title: 'Periodos De Pago Del ISSSTE',
                icon: null,
                component: CalendarioPagosISSSTE,
                ...CalendarioPagosISSSTEPermission,
              },
            ],
          },
        ],
      },
      {
        title: 'Instituto de Pensiones del Estado de Jalisco',
        children: [
          {
            title: 'IPEJAL Percepciones',
            icon: null,
            component: PercepcionConfiguracionIPEJAL,
            ...percepcionConfiguracionIPEJALPermission,
          },
          {
            title: 'Tasas de IPEJAL',
            icon: null,
            component: TasasIPEJAL,
            ...tasasIPEJALPermission,
          },
        ],
      },
    ],
  },
  {
    title: 'Valores de Referencia',
    icon: () => <AiOutlineBook />,
    children: [
      {
        title: 'Zona de Salario Mínimo',
        icon: null,
        component: ZonaDeSalarioMinimo,
        ...zonaDeSalarioMinimoPermission,
      },
      {
        title: 'Salario Mínimo General',
        icon: null,
        component: SalarioMinimoGeneral,
        ...salarioMinimoGeneralPermission,
      },
      {
        title: 'Salario Mínimo Municipal',
        icon: null,
        component: SalarioMinimoMunicipal,
        ...salarioMinimoMunicipalPermission,
      },
      {
        title: 'Antigüedad para Incapacidad',
        icon: null,
        component: IncidenciaAntiguedadParaEnfermedadGeneral,
        ...incidenciaAntiguedadParaEnfermedadGeneralPermission,
      },
      {
        title: ' UMA',
        icon: null,
        component: UmaGeneral,
        ...umasGeneralesPermission,
      },
      {
        title: 'Importe Anual ISR',
        icon: null,
        component: ImporteAnualISR,
        ...importeAnualISRPermission,
      },
    ],
  },
  // {
  //   title: 'Consultas',
  //   icon: () => <AiOutlineFileSearch />,
  //   children: [
  //     {
  //       title: 'Nómina de Empleado',
  //       icon: null,
  //       component: ConsultaDeNomina,
  //     },
  //     {
  //       title: 'Capacidad de Crédito',
  //       icon: null,
  //       component: CapacidadCredito,
  //     },
  //     {
  //       title: 'Constancia de Aportaciones',
  //       icon: null,
  //       component: ConstanciaDeAportaciones,
  //     },
  //     {
  //       title: 'Recibo de Finiquito',
  //       icon: null,
  //       component: ReciboFiniquito,
  //     },
  //     {
  //       title: 'Supervivencia',
  //       icon: null,
  //       component: ConsultaComprobanteDeSupervivencia,
  //       ...historialComprobanteDeSupervivenciaPermission,
  //     },
  //     {
  //       title: 'Vacaciones',
  //       icon: null,
  //       component: ConsultaVacaciones,
  //     },
  //     {
  //       title: 'Retención de Pago',
  //       icon: null,
  //       component: ConsultaRetencionDePago,
  //     },
  //     {
  //       title: 'Descuentos de Ahorro y Préstamos',
  //       icono: null,
  //       component: DescuentoDeAhorroYPrestamo,
  //     },
  //   ],
  // },
  {
    title: 'Catálogos',
    icon: AiTwotoneContainer,
    children: [
      {
        title: 'Operativos',
        icon: null,
        children: [
          {
            title: 'Tipos',
            icon: null,
            children: [
              {
                title: 'Tipos de Nóminas de Empleado',
                icon: null,
                component: TipoDeNominaEmpleado,
                ...tipoDeNominaEmpleadoPermission,
              },
              {
                title: 'Tipos de Empleado Presupuestal',
                icon: null,
                component: TipoDeEmpleadoPresupuestal,
                ...tipodeempleadopresupuestalPermission,
              },
              {
                title: 'Tipos de Origen de Contratación',
                icon: null,
                component: TipoDeOrigenDeContratacion,
                ...tipodeorigendecontratacionPermission,
              },
              {
                title: 'Tipos de Empleados',
                icon: null,
                component: TipoDeEmpleado,
                ...tipodeempleadoPermission,
              },
              {
                title: 'Tipos de Funciones',
                icon: null,
                component: TiposDeFunciones,
                ...tipoDeFuncionPermission,
              },
              {
                title: 'Tipos de Plazas',
                icon: null,
                component: TiposDePlazas,
                ...tiposDePlazasPermission,
              },
              {
                title: 'Tipos de Descuentos',
                icon: null,
                component: TiposDeDescuentos,
                ...tiposDescuentoPermission,
              },
              {
                title: 'Tipos de Seguridad Social',
                icon: null,
                component: TiposDeSeguridadesSociales,
                ...tipoDeSeguridadSocialPermission,
              },
              {
                title: 'Tipos de Identificación',
                icon: null,
                component: TipoDeIdentificacion,
                ...tipodeidentificacionPermission,
              },
              {
                title: 'Tipos de Contratación',
                icon: null,
                component: TipoDeContratacion,
                ...tipodecontratacionPermission,
              },
              {
                title: 'Tipos de Asignación De Plazas',
                icon: null,
                component: TipoAsignacionPlaza,
                ...tipodeasignaciondeplazaPermission,
              },
              {
                title: 'Tipos de Justificación',
                icon: null,
                component: ClockJustificacion,
                ...tipoDeJustificacionPermission,
              },
              {
                title: 'Tipos de Checado',
                icon: null,
                component: TiposDeChecado,
                ...tipoDeChecadoPermission,
              },
              {
                title: 'Tipos de Evaluación de Asistencia',
                icon: null,
                component: ClockEvaluacionAsistencia,
                ...tipoDeEvaluacionAsistenciaPermission,
              },
              {
                title: 'Tipos de Actividad',
                icon: null,
                component: TiposDeActividades,
                ...tiposDeActividadesPermission,
              },
              {
                title: 'Tipos de Movimientos',
                icon: null,
                component: TiposDeMovimientosDePersonal,
                ...tipodemovimientodepersonalPermission,
              },
              {
                title: 'Movimientos de Personal',
                icon: null,
                component: MovimientosDePersonal,
                ...movimientodepersonalPermission,
              },
            ],
          },
          {
            title: 'Reclutamiento',
            icon: null,
            children: [
              {
                title: 'Pruebas y Otros',
                icon: null,
                component: PruebasYOtros,
                ...pruebasYOtrosPermission,
              },
            ],
          },
          {
            title: 'Motivos',
            icon: null,
            children: [
              {
                title: 'Motivos de Movimiento',
                icon: null,
                component: MotivoDeMovimientoDeEmpleados,
                ...motivoDeMovimientoDeEmpleadosPermission,
              },
              {
                title: 'Motivos de Liquidación',
                icon: null,
                component: MotivosDeLiquidaciones,
                ...motivosDeLiquidacionesPermission,
              },
              {
                title: 'Motivos de Retención',
                icon: null,
                component: MotivosDeRetencionDePagos,
                ...motivosDeRetencionDePagosPermission,
              },
              {
                title: 'Motivos de Suspensión',
                icon: null,
                component: MotivosDeSuspensionDePagos,
                ...motivodesuspensiondepagoPermission,
              },
              {
                title: 'Motivos de Permisos',
                icon: null,
                component: MotivoPermisos,
                ...motivoPermisosPermission,
              },
              {
                title: 'Motivos de Reclutamiento',
                icon: null,
                component: MotivoRecutamiento,
                ...motivoPermisosPermission, // Cambiar permiso
              },
              {
                title: 'Motivos de Baja de Nombramientos',
                icon: null,
                component: MotivosBajaNombramientos,
                ...motivosBajaNombramientosPermission,
              },
            ],
          },
          {
            title: 'Periodicidad',
            icon: null,
            children: [
              {
                title: 'Periodicidad de Pago',
                icon: null,
                component: PeriodicidadDePago,
                ...periodicidaddepagoPermission,
              },
              {
                title: 'Periodicidad de Percepciones',
                icon: null,
                component: PeriodicidadDePercepcion,
                ...periodicidadDePercepcionPermission,
              },
              {
                title: 'Periodicidad de Aplicación',
                icon: null,
                component: ClockPeriocidad,
                ...niveldeestudioPermission, // cambiar permiso
              },
            ],
          },
          {
            title: 'Categorías',
            icon: null,
            children: [
              {
                title: 'Categoría de Empleados',
                icon: null,
                component: CategoriaDePuesto,
                ...categoriasDePuestosPermission,
              },
              {
                title: 'Categorías de Incapacidades',
                icon: null,
                component: CategoriasIncapacidades,
                ...categoriaIncapacidadesPermission,
              },
              {
                title: 'Subcategoría de Incapacidades',
                icon: null,
                component: SubcategoriasIncapacidades,
                ...subcategoriaIncapacidadesPermission,
              },
            ],
          },
          {
            title: 'Nombramientos',
            icon: null,
            children: [
              {
                title: 'Carácter de Nombramiento',
                icon: null,
                component: CaracterDeNombramiento,
                ...caracterDeNombramientoPermission,
              },
              {
                title: 'Prestaciones para Nombramientos',
                icon: null,
                component: NombramientosPrestaciones,
                ...presentacionparanombramientoPermission,

              },
            ],
          },
          {
            title: 'Estudios',
            icon: null,
            children: [
              {
                title: 'Nivel De Estudios',
                icon: null,
                component: NivelDeEstudio,
                ...niveldeestudioPermission,
              },
              {
                title: 'Abreviatura de Carrera',
                icon: null,
                component: AbreviaturaDeCarrera,
                ...abreviaturadecarreraPermission,
              },
              {
                title: 'Especialidad de Estudios',
                icon: null,
                component: EspecialidadDeEstudio,
                ...especialidadesDeEstudiosPermission,
              },

              {
                title: 'Comprobante De Estudios',
                icon: null,
                component: ComprobantesDeEstudios,
                ...comprobantedeestudioPermission,
              },
            ],
          },
          {
            title: 'Seguridad Social',
            children: [

              {
                title: 'Seguridad Social',
                icon: null,
                component: Seguridadsocial,
                ...SeguridadSocialPermission,
              },
            ],
          },
          {
            title: 'Otros',
            icon: null,
            children: [

              {
                title: 'Fuentes de Reclutamiento',
                icon: null,
                component: FuentesDeReclutamiento,
                ...fuentesDeReclutamientoPermission,
              },
              {
                title: 'Porcentaje de Pago de Sueldo',
                icon: null,
                component: PorcentajePagoSueldo,
                ...porcentajePagoSueldoPermission,
              },
              {
                title: 'Sindicato(s)',
                icon: null,
                component: Sindicato,
                ...sindicatoPermission,
              },
              {
                title: 'Categoría de Iconografía',
                icon: null,
                component: CategoriaDeIconografia,
                ...permissionCategoriaDeIconografia,
              },
              {
                title: 'Iconografía de Seguimiento',
                icon: null,
                component: IconografiaDeSeguimiento,
                ...permissionIconografiaDeSeguimiento,
              },

              {
                title: 'Referencia',
                icon: null,
                component: PreferenciaPartidaria,
                ...preferenciapartidariaPermission, // Cambiar permiso
              },
              {
                title: 'Estructuras Jerárquicas',
                icon: null,
                component: EstructurasJerarquicas,
                ...sindicatoPermission, // Cambiar permiso
              },
              {
                title: 'Periodos Vacacionales',
                icon: null,
                component: ConfigurarPeriodosVacacionales,
                ...configurarPeriodosVacacionalesPermission, // Cambiar permiso
              },
              {
                title: 'Documentos para Anexar',
                icon: null,
                component: DocumentosParaLiquidaciones,
                ...documentosParaLiquidacionesPermission,
              },
            ],
          },
        ],
      },
      {
        title: 'Catálogos SAT-CFDI',
        icon: null,
        children: [
          {
            title: 'Banco',
            icon: null,
            component: Banco,
            ...bancodenominaPermission,
          },
          {
            title: 'Origen del Recurso',
            icon: null,
            component: OrigenRecurso,
            ...origenrecursonominaPermission,
          },
          {
            title: 'Periodicidad Pago',
            icon: null,
            component: PeriodicidadPagoNomina,
            ...periodicidadpagonominaPermission,
          },
          {
            title: 'Tipos de Contratos',
            icon: null,
            component: TipoContrato,
            ...tipocontratonominaPermission,
          },
          {
            title: 'Tipos de Deducción',
            icon: null,
            component: TipoDeduccion,
            ...tipodeduccionnominaPermission,
          },
          {
            title: 'Tipos de Horas',
            icon: null,
            component: TipoHoras,
            ...tipohorasnominaPermission,
          },
          {
            title: 'Tipos de Incapacidades',
            icon: null,
            component: TipoIncapacidad,
            ...tipoincapacidadnominaPermission,
          },
          {
            title: 'Tipos de Jornadas',
            icon: null,
            component: TipoJornada,
            ...tipojornadanominaPermission,
          },
          // {
          //   title: 'Tipos de Nóminas',
          //   icon: null,
          //   component: TipoNomina,
          //   ...tiponominaPermission,
          // },
          {
            title: 'Tipos de Otros Pagos',
            icon: null,
            component: TipoOtroPago,
            ...otrotipopagonominaPermission,
          },
          {
            title: 'Tipos de Percepción',
            icon: null,
            component: TipoPercepcion,
            ...tipopercepcionnominaPermission,
          },
          {
            title: 'Tipos de Régimen',
            icon: null,
            component: TipoRegimen,
            ...tiporegimennominaPermission,
          },
          {
            title: 'Riesgos de Puesto',
            icon: null,
            component: RiesgoPuesto,
            ...riesgopuestonominaPermission,
          },
        ],
      },
      {
        title: 'Catálogos SAC',
        icon: null,
        children: [
          {
            title: 'Generales',
            // no component: esto se renderiza como encabezado de grupo
            children: [
              {
                title: 'Acreedores',
                component: Acreedores,
                ...acreedorPermission,
              },
              {
                title: 'Beneficiarios',
                component: Beneficiarios,
                type: 'private',
                showInSidebar: true,
                ...permissionBeneficiario,
              },
              {
                title: 'Catálogo Contable',
                icon: null,
                component: CatalogoContable,
                ...permissionCuentaContable, // cambiar permiso
              },
              // {
              //   title: 'Catálogo Contable',
              //   component: ClavesContables,
              //   type: 'private',
              //   showInSidebar: true,
              //   ...permissionCuentaContable,
              // },
            ],
          },
          // { //Anterior Directorio de áreas
          //   title: 'Directorio de Áreas',
          //   icon: null,
          //   showInSidebar: true,
          //   component: DirectorioURs,
          //   type: 'private',
          //   permissionModel: 'centrodecostos',
          // },
          {
            title: 'Presupuestales',
            children: [
              {
                title: 'Clasificador por Objeto del Gasto',
                component: ClasificadorPorObjetoDelGasto,
                ...clasificadorPorObjetoDelGastoPermission,
              },
              {
                title: 'Catálogo de Fuentes de Financiamiento',
                component: FuenteDeFinanciamiento,
                type: 'private',
                showInSidebar: true,
                ...permissionFuenteDeFinanciamiento,
                catalogsModels: ['clasificaciondefuentedefinanciamiento'],
              },
              {
                title: 'Tipos de Gasto',
                component: TiposDeGasto,
                type: 'private',
                showInSidebar: true,
                ...tipoDeGastoPermission,
              },
              {
                title: 'Clasificación Programática',
                icon: null,
                showInSidebar: true,
                component: ClasificacionProgramatica,
                type: 'private',
                ...permissionClasificacionProgramatica,
              },
              {
                title: 'Clasificación Funcional',
                icon: null,
                showInSidebar: true,
                component: ClasificacionFuncional,
                type: 'private',
                ...permissionClasificacionFuncional,
              },
              {
                title: 'Clasificación Administrativa',
                icon: null,
                showInSidebar: true,
                component: ClasificacionAdministrativa,
                type: 'private',
                ...permissionClasificacionAdministrativa,
              },
              {
                title: 'Programas Presupuestales',
                component: ProgramasPresupuestales,
                type: 'private',
                showInSidebar: true,
                ...programasPresupuestalesPermission,
              },
              {
                title: 'Proyectos Presupuestales',
                icon: null,
                component: ProyectosPresupuestales,
                ...sindicatoPermission, // Cambiar permiso si aplica
              },
              {
                title: 'Destinos Presupuestales',
                icon: null,
                component: DestinosPresupuestales,
                type: 'private',
                showInSidebar: true,
                ...permissionDestinosPresupuestales,
              },
              {
                title: 'Segmentos Presupuestales',
                icon: null,
                showInSidebar: true,
                component: ConfiguracionDeSegmentos,
                type: 'private',
                ...permissionConfigSegmentoPresupuestal,
                catalogsModels: ['tipodepresupuesto'],
              },
            ],
          },
          // {
          //   title: 'Contables',
          //   children: [
          //     {
          //       title: 'Segmentos Contables',
          //       icon: null,
          //       showInSidebar: true,
          //       component: ConfiguracionDeSegmentosContables,
          //       type: 'private',
          //       ...permissionConfigSegmentoContable,
          //     },
          //     {
          //       title: 'Configuración de Máscaras',
          //       icon: null,
          //       showInSidebar: true,
          //       component: ConfiguracionDeMascaras,
          //       type: 'private',
          //       ...permissionConfigMascara,
          //       catalogsModels: ['tipodemascara'],
          //     },
          //   ],
          // },

          /*  {
              title: 'Fuentes de Financiamiento',
              icon: null,
              component: FuentesDeFinanciamiento,
              ...FuentesDeFinanciamientoPermission,
            },  */
        ],
      },
      {
        title: 'Tipos de Gasto',
        component: TiposDeGasto,
        ...tipoDeGastoPermission,
      },
    ],
  },
  {
    title: 'Configuración',
    icon: () => <AiFillSetting />,
    children: [
      {
        title: 'Entidad Pública',
        icon: null,
        component: EntidadMunicipal,
        ...entidadPermission,
      },

      {
        title: 'Constructor de Gráficas',
        icon: null,
        component: ConstructorDeGraficas,
      },

      {
        title: 'Accesos',
        icon: null,
        children: [
          {
            title: 'Roles de Usuario',
            icon: null,
            component: RolesDeUsuario,
            ...rolesUsuariosPermission,
          },
          {
            title: 'Roles y Usuarios',
            icon: null,
            component: RolesYUsuarios,
            ...rolesYUsuariosPermission,
          },
          {
            title: 'Permisos Sidebar',
            icon: null,
            component: PermisosSidebar,
            ...permisosSidebarPermission,
          },
          {
            title: 'Funciones de Usuarios',
            icon: null,
            component: FuncionesDeUsuario,
            ...usuarioFuncionPermission,
          },
          {
            title: 'Usuarios',
            component: Usuarios,
            ...usuariosPermission,
          },
          {
            title: 'Bitácora de Auditoría',
            icon: null,
            component: BitacoraAuditoria,
            ...bitacoraAuditoriaPermission,
          },
          {
            title: 'Limitación Autorización Nombramientos',
            icon: null,
            component: LimitacionAutorizacionNombramientos,
            ...limitacionAutorizacionNombramientosPermission,
          },
          {
            title: 'Limitación Autorización Contrataciones',
            icon: null,
            component: LimitacionAutorizacionContrataciones,
            ...limitacionAutorizacionContratacionesPermission,
          },
          {
            title: 'Limitación Administración Plazas',
            icon: null,
            component: LimitacionAdministracionPlazas,
            ...limitacionAdministracionPlazasPermission,
          },
        ],
      },

      {
        title: 'Configuraciones',
        icon: null,
        children: [
          {
            title: 'IMSS',
            icon: null,
            children: [
              {
                title: 'Seguros IMSS',
                icon: null,
                component: ConfiguracionSeguroIMSS,
                ...ConfiguracionSeguroIMSSPermission,
              },
              {
                title: 'Percepciones IMSS',
                icon: null,
                component: PercepcionIMSS,
                ...PercepcionIMSSPermission,
              },
            ],
          },
          {
            title: 'ISSSTE',
            icon: null,
            children: [
              {
                title: 'Seguros ISSSTE',
                icon: null,
                component: ConfiguracionSeguroISSSTE,
                ...ConfiguracionSeguroISSSTEPermission,
              },
              {
                title: 'Percepciones ISSSTE',
                icon: null,
                component: PercepcionISSSTE,
                ...PercepcionISSSTEPermission,
              },
            ],
          },
          {
            title: 'Configuración de Percepciones',
            icon: null,
            component: Percepcion,
            ...percepcionesPermission,
          },
          {
            title: 'Configuración de Deducciones',
            icon: null,
            component: Deduccion,
            ...deduccionPermission,
          },
          {
            title: 'Configuración de Incidencias',
            icon: null,
            component: ConfiguracionIncidencias,
            ...configuracionIncidenciaPermission,
          },
          {
            title: 'Configuración de Solicitudes de Percepción',
            icon: null,
            component: ConfiguracionSolicitudes,
            ...configuracionSolicitudPermission,
          },
          {
            title: 'Parámetros de Solicitudes de Percepción',
            icon: null,
            component: SolcitudesParametros,
            ...solicitudParametroPermission,
          },
          {
            title: 'Configuración de Descuentos',
            icon: null,
            component: DescuentosConfiguraciones,
            ...descuentosConfiguacionesPermission,
          },
          {
            title: 'Configuración de Liquidaciones',
            icon: null,
            component: LiquidacionesConfiguraciones,
            ...liquidacionConfiguracionPermission,
          },
          {
            title: 'Configuración de Vacaciones',
            icon: null,
            component: VacacionesConfiguracion,
            ...vacacionesConfiguracionPermission,
          },
          {
            title: 'Configuración Carga Externa de Descuentos',
            icon: null,
            component: ConfiguracionCargaExternaDescuento,
            ...ConfiguracionCargaExternaDescuentoPermission,
          },
          {
            title: 'Configuración de Reloj Checador',
            icon: null,
            children: [
              {
                title: 'General',
                icon: null,
                component: IncidenciaGeneral,
                ...incidenciaGeneralPermission,
              },
              {
                title: 'Parámetros',
                icon: null,
                component: ParamaetrosConfigReloj,
                ...ParametrosConfigPermission,
              },
              {
                title: 'Carga',
                icon: null,
                component: CargaConfigReloj,
                ...cargaConfigPermission,
              },
              {
                title: 'Relación',
                icon: null,
                component: RelacionConfigReloj,
                ...relacionConfigPermission,
              },
              {
                title: 'Tolerancia',
                icon: null,
                component: ToleranciaConfigReloj,
                ...toleranciaConfigPermission,
              },
              {
                title: 'Tope de Justificaciones',
                icon: null,
                component: TopeJustificacionesConfigReloj,
                ...topeJustificacionesConfigPermission,
              },
              {
                title: 'Periodicidad',
                icon: null,
                component: PeriodicidadConfigReloj,
                ...periodicidadConfigPermission,
              },
              {
                title: 'Validaciones',
                icon: null,
                component: ValidacionesConfigReloj,
                ...validacionesConfigPermission,
              },
            ],
          },
          {
            title: 'Configurador de Guardias Vacacionales y Vacaciones',
            icon: null,
            component: ConfigurarGuardiasVacacionalesGeneral,
            ...configurarGuardiasVacacionalesGeneralPermission,
          },
          {
            title: 'Configurador de Contribuciones Plaza',
            icon: null,
            component: ConfiguradorDeContribucionesPlaza,
            // ...listadoDeVacantes, // cambiar permiso
            ...contribucionesPlazaPermission,
          },
          {
            title: 'Configurador de Nóminas Acumuladas',
            icon: null,
            component: AcumuladosNominasColumnas,
            ...acumuladoNominaColumnaPermission,
          },
          {
            title: 'Configuración de Pólizas de Carga Externa',
            icon: null,
            component: ConfiguradorPolizasCargaExterna,
            ...configuradorPolizasCargaExternaPermission,
          },
          {
            title: 'Configuracion de Dispersion Bancaria',
            icon: null,
            component: ConfiguracionDispersionBancaria,
            ...configuracionDispersionBancariaPermission,
          },
          {
            // PRUEBA - BORRAR DESPUES
            title: 'Prueba Generador de Pólizas de Carga Externa',
            icon: null,
            component: PruebaGeneradorPolizasCargaExterna,
            ...configuradorPolizasCargaExternaPermission,
          },
          {
            title: 'Configurador de Firmado de Documentos',
            icon: null,
            component: ConfiguradorFirmadoDeDocumentos,
            ...configuradorFirmadoDeDocumentosPermission,
          },
        ],
      },

    ],
  },
];
